import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import * as layouts from "layouts"
import * as sessions from "sessions"
import * as api from "./api"
import * as cache from "./cache"

interface videoProps {
	media: api.Media
	onClick?(media: api.Media, url: string): void
}

const StyledVideo = styled.video`
	width: 100%;
	height: 100%;
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
`

export function Video(props: React.PropsWithChildren<videoProps> & layouts.containers.FlexProps): JSX.Element {
	const { media, onClick, children, ...rest } = props
	const [response, setResponse] = useState({} as api.RedirectResponse)
	const [loading, setLoading] = useState(false)
	const account = sessions.useAccount()
	const bearertoken = sessions.useToken()

	useEffect(() => {
		setLoading(true)
		cache
			.current(account.id, media.content_digest, bearertoken)
			.then((url) => setResponse({ url: url }))
			.catch((cause) => console.error("unable to load video", cause))
			.finally(() => setLoading(false))
	}, [media.content_digest])

	const v = response.url ? (
		<StyledVideo
			controls
			onClick={onClick ? () => onClick(media, response.url) : undefined}
		>
			<source src={response.url} type={media.mimetype || "video/mp4"} />
			Your browser does not support the video tag.
		</StyledVideo>
	) : (
		<layouts.containers.flex className="zero" width="100%" height="auto" />
	)

	return (
		<layouts.containers.flex
			flexDirection="column"
			overflow="hidden"
			flex="1"
			{...rest}
		>
			<layouts.loading.screen loading={loading} flex="1" icon={<></>} height="100%">
				{v}
				{media.description ? (
					<layouts.containers.flex justifyContent="center">
						<layouts.containers.flex
							height="12px"
							fontWeight="700"
							fontSize="8px"
							lineHeight="12px"
							color={layouts.theme.colors.grey.dark5}
							overflow="hidden"
							mx="auto"
							style={{ whiteSpace: "nowrap", textOverflow: "ellipsis" }}
						>
							{media.description}
						</layouts.containers.flex>
					</layouts.containers.flex>
				) : null}
			</layouts.loading.screen>
			{children}
		</layouts.containers.flex>
	)
}
